import TextM from "@common/components/text/TextM"
import { useQuizCorrectionData } from "@common/hooks/useQuizCorrectionData"
import { ModalSkeleton } from "@common/modals/ModalSkeleton"
import { theme } from "@common/theme/theme"
import React from "react"
import { View } from "react-native"
import QuizCorrectionReview from "./QuizCorrectionReview"
import QuizScoreRing from "./QuizScoreRing"

/**
 * QuizReviewModal — retroactive view of the student's last attempt.
 *
 * Loads the quiz once per activity and renders a score banner + the full
 * per-question correction (correct + wrong) through QuizCorrectionReview,
 * which is handed the payload rather than fetching it a second time.
 */
const QuizReviewModal = ({ isVisible, onClose, activityId }) => {
    const { data, loading, error } = useQuizCorrectionData({
        activityId,
        enabled: isVisible,
    })

    const attempt = data?.latest_attempt
    const passed = attempt?.passed

    return (
        <ModalSkeleton
            isVisible={isVisible}
            onClose={onClose}
            title="Ton quiz"
            loading={loading && !data}
            // The correction below owns its own scroll area; letting the modal
            // scroll too would stack a second scrollbar beside it and let the
            // title and score ring slide out of view.
            scrollable={false}
        >
            {error && !data ? (
                <TextM color={theme.colors.error} wrap fontSize={13}>
                    {error}
                </TextM>
            ) : !attempt ? (
                <TextM color={theme.colors.grey} wrap>
                    Tu n'as pas encore fait ce quiz.
                </TextM>
            ) : (
                <View>
                    <View style={{ alignItems: "center", marginBottom: 20, marginTop: 4 }}>
                        <QuizScoreRing
                            score={attempt.score ?? 0}
                            total={attempt.total ?? 0}
                            passed={!!passed}
                        />
                    </View>

                    {/* Smaller than in Sam: the title and the score ring sit
                        above it inside a modal capped at 90% of the screen. */}
                    <QuizCorrectionReview data={data} heightRatio={0.45} />
                </View>
            )}
        </ModalSkeleton>
    )
}

export default QuizReviewModal
